export default "__VITE_ASSET__Cthc1DIM__"